import { GeneralSummary } from "@/types/analysisSummary";
import { DatasetDataType } from "@/types/dataset";

export const generalSummaryData: GeneralSummary = {
  data: {
    attributes: [
      {
        attribute_name: "score",
        data_type: DatasetDataType.TYPE_FLOAT,
        rows: [
          {
            catchment_id: "888c1078c1fffff",
            value: 1.2041199826559248
          },
          {
            catchment_id: "888c1078d7fffff",
            value: 1.1760912590556811
          },
          {
            catchment_id: "888c1078adfffff",
            value: 1.0791812460476249
          },
          {
            catchment_id: "888c107889fffff",
            value: 1.0791812460476249
          },
          {
            catchment_id: "888c1078d5fffff",
            value: 1.0791812460476249
          },
          {
            catchment_id: "888c1078c7fffff",
            value: 1.0791812460476249
          },
          {
            catchment_id: "888c1078c5fffff",
            value: 1
          },
          {
            catchment_id: "888c1078e9fffff",
            value: 0.954242509439325
          },
          {
            catchment_id: "888c1078c9fffff",
            value: 0.954242509439325
          },
          {
            catchment_id: "888c1078e1fffff",
            value: 0.9030899869919435
          }
        ]
      },
      {
        attribute_name: "population",
        data_type: DatasetDataType.TYPE_FLOAT,
        rows: [
          {
            catchment_id: "888c1078c1fffff",
            value: 15000
          },
          {
            catchment_id: "888c1078d7fffff",
            value: 12500
          },
          {
            catchment_id: "888c1078adfffff",
            value: 11000
          },
          {
            catchment_id: "888c107889fffff",
            value: 10800
          },
          {
            catchment_id: "888c1078d5fffff",
            value: 10500
          },
          {
            catchment_id: "888c1078c7fffff",
            value: 10200
          },
          {
            catchment_id: "888c1078c5fffff",
            value: 9800
          },
          {
            catchment_id: "888c1078e9fffff",
            value: 9500
          },
          {
            catchment_id: "888c1078c9fffff",
            value: 9200
          },
          {
            catchment_id: "888c1078e1fffff",
            value: 8900
          }
        ]
      }
    ],
    general: {
      avg_score: 98.4,
      max_score: 84.4,
      median_score: 45.4,
      min_score: 76.4,
      total_rows: 244
    }
  }
};

export const generalSummaryDataPolygon: GeneralSummary = {
  data: {
    attributes: [
      {
        attribute_name: "Polygon Size (km²)",
        data_type: DatasetDataType.TYPE_FLOAT,
        rows: [
          {
            polygon_id: "2",
            value: 1.7619147462703957
          },
          {
            polygon_id: "1",
            value: 1.0347322590949326
          }
        ]
      },
      {
        attribute_name: "Score",
        data_type: DatasetDataType.TYPE_FLOAT,
        rows: [
          {
            polygon_id: "1",
            value: 22
          },
          {
            polygon_id: "2",
            value: 10
          }
        ]
      },
      {
        attribute_name: "Count of POI Bank and Financial Jabodetabek Area 2025",
        data_type: DatasetDataType.TYPE_INTEGER,
        rows: [
          {
            polygon_id: "1",
            value: 22
          },
          {
            polygon_id: "2",
            value: 10
          }
        ]
      }
    ],
    general: {
      avg_score: 16,
      max_score: 22,
      median_score: 16,
      min_score: 10,
      total_rows: 2
    }
  }
};

export const aiSummaryContent = `### 1. General Summary

This analysis examines performance scores across geographic grid areas at level 7 H3 grid type, analyzing a total of 40 grid areas.

*   **Highest Scoring Grid**: The highest performing grid, identified as 878c10681ffffff, achieved a score of 19713.01. This grid's performance is associated with areas such as Cengkareng Timur (Rank 1, 48.84% coverage), Kamal Muara (Rank 2, 19.99% coverage), and Kapuk (Rank 3, 19.11% coverage). Key attributes include a high density of banks/financial POIs (103) and education POIs (102), reflecting a diverse socioeconomic landscape with significant proportions across all classes: High (20.08%), Low (19.20%), Medium-High (11.68%), and Medium-Low (49.05%).
*   **Lowest Scoring Grid**: The lowest performing grid, identified as 878c13d24ffffff, scored 2608.37. This grid intersects areas such as Kosambi Timur (Rank 1, 26.08% coverage), Cengklong (Rank 2, 23.12% coverage), and Jati Mulya (Rank 3, 23.04% coverage). This grid has fewer POIs (0 bank/financial and 1 education), with a low socioeconomic class proportion of 4.79%.
*   **Key Differences**: The highest scoring grid outperforms the lowest scoring grid by a substantial margin, driven by significantly greater POI density, a more balanced distribution of socioeconomic classes, and higher population distribution (penduduk_proportion of 157470 vs. 20857). The administrative area coverage also differs significantly, with the highest performing grid concentrated in Jakarta Barat and Jakarta Utara, while the lowest performing grid is primarily in Tangerang.

---

### 2. High Concentration Areas (Top 25% Performance)

The threshold for the top 25% performance is a score of 13616.68, with 10 grid areas exceeding this threshold.

*   Scores within the top-performing group range from 15563.13 to 19713.01.
*   These areas generally exhibit a mix of high and low socioeconomic classes, often with a strong presence of medium-high classifications.
*   High POI density, particularly bank/financial institutions and educational facilities, is a common trait.
*   Geographically, these grids are concentrated in Jakarta Barat, Jakarta Pusat, and Jakarta Utara, suggesting a cluster in central and northern Jakarta.

The strong performance in these areas appears driven by a combination of socioeconomic diversity, robust infrastructure (as indicated by high POI counts), and strategic location within densely populated areas of Jakarta. The clustering effect suggests network effects or localized economic advantages.`;
